<!-- If auth service or user service is loading, show loading spinner. Else, show main -->
<ng-container>
  @if (loading$ | async) {
    <div class="full-screen-spinner">
      <mat-spinner diameter="60"></mat-spinner>
    </div>
  } @else {
    <!-- If user is not undefined (application has loaded), show application content. Else, show unauthenticated content -->
    @if ((active$ | async)) {
      <mat-sidenav-container class="sidenav-container" autosize>
        <!-- only render sidenav when application (user) has loaded and TOS is accepted -->
        @if (!(loading$ | async)) {
          <mat-sidenav mode="side" [opened]="tosAccepted$ | async" [ngClass]="{ 'expand': sidenavExpand }" [disableClose]="true">
            <app-navigation (sidenavToggled)="sidenavToggled($event)"></app-navigation>
          </mat-sidenav>
        }
        <!-- Authenticated view -->
        <mat-sidenav-content class="sidenav-content">
          <div>
            <app-header class="header"></app-header>
            <router-outlet class="main"></router-outlet>
          </div>
        </mat-sidenav-content>
      </mat-sidenav-container>
    } @else {
      <router-outlet></router-outlet>
    }
  }
</ng-container>


<!-- Unauthenticated View -->
